<template id="modal-template">
  <div v-if="showModal == true" @click.stop>
    <!-- @click="closeModal" -->
    <vs-row>
      <vs-col vs-offset="7">
        <transition name="fade">
          <div class="modal">
            <div class="modal__backdrop">
              <div class="modal__dialog">
                <div class="modal__header">
                  <slot name="header">
                    <h4 style="margin-left: 20px">Add Point Category</h4>
                    <vue-load-image>
                      <img
                        class="ml-1 topright"
                        slot="image"
                        :src="require('@/assets/images/x/close.png')"
                        height="50"
                        width="47"
                        @click="closeModal"
                      />
                    </vue-load-image>
                  </slot>
                </div>

                <div class="modal__body">
                  <vs-row class="catBgClr mx-4">
                    <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->
                  </vs-row>

                  <div class="addCardFont font-semibold ml-5 mt-3">
                    Points Category
                  </div>

                  <vs-input
                    type="text"
                    class="w-full p-5 pb-3"
                    v-model="newPointCategory"
                    @keyup.enter="savePointCategory()"
                  />
                  <vs-row v-if="errors.pointCategories.success">
                    <p class="p-5 py-3 pt-1 dangerColor">
                      {{ errors.pointCategories.msg }}
                    </p>
                  </vs-row>
                  <vs-row class="mt-0 pr-2 mb-1" vs-justify="center">
                    <vs-col vs-offset="9">
                      <vs-button
                        style="
                          width: 138px;
                          position: absolute;
                          bottom: 0;
                          margin-bottom: 15px;
                        "
                        @click="savePointCategory()"
                        >Save</vs-button
                      >
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import VueLoadImage from "vue-load-image";
import Datepicker from "vuejs-datepicker";
import draggable from "vuedraggable";
import Editor from "@tinymce/tinymce-vue";
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
  MenuIcon,
} from "vue-feather-icons";

export default {
  props: ["pointsCategoriesOption", "showModal"],
  data() {
    return {
      field: this.fields,
      menu: false,
      modal: false,
      tempArray: [],
      isfirst: false,
      newPointCategory: "",
      //pointsCategoriesOption: this.pointsCategoriesOption,
      //bonusCategory: [],
      errors: {
        pointCategories: {
          msg: "",
          success: false,
        },
      },
    };
  },
  methods: {
    handleSelect(data) {},
    async closeModal() {
      this.errors.pointCategories.msg = "";
      this.errors.pointCategories.success = false;
      this.newPointCategory = "";
      this.$emit("close_modal_dismiss", false);
    },
    async savePointCategory() {
      if (this.newPointCategory && this.newPointCategory.trim() != "") {
        if (
          this.pointsCategoriesOption &&
          this.pointsCategoriesOption.length > 0
        ) {
          let tempCategory = this.pointsCategoriesOption.find(
            (a) =>
              a.name &&
              a.name.toString().toLowerCase() ==
                this.newPointCategory.toLowerCase()
          );
          if (tempCategory != null) {
            this.errors.pointCategories.msg = "Points Category already exists";
            this.errors.pointCategories.success = true;
          } else {
            this.SaveNewCategories();
            this.errors.pointCategories.msg = "";
            this.errors.pointCategories.success = false;
          }
        } else {
          this.SaveNewCategories();
          this.errors.pointCategories.msg = "";
          this.errors.pointCategories.success = false;
        }
      } else {
        this.errors.pointCategories.msg =
          "Points Category field cannot be empty";
        this.errors.pointCategories.success = true;
      }
    },
    SaveNewCategories() {
      this.$vs.loading({
        background: "rgba(1,2,3,.2)",
      });
      return new Promise((resolve) => {
        this.$axios
          .post(
            this.$ApiKeys.BASE_URL +
              this.$EndPoints.AdminSaveSinglePointCategory,
            {
              newPointCategory: this.newPointCategory,
            },
            {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            }
          )
          .then(async (res) => {
            this.$vs.loading.close();
            if (res.data.success) {
              let tempAllCategories;
              resolve((tempAllCategories = res.data.data));
              this.$emit(
                "close_modal_success",
                tempAllCategories,
                this.newPointCategory
              );
              this.newPointCategory = "";
            } else {
              this.errors.pointCategories.msg = res.data.data;
              this.errors.pointCategories.success = true;
              // this.toast(this.genericErrorMessage());
              // this.$emit("close_modal_dismiss", false);
            }
          })
          .catch((e) => {
            this.$vs.loading.close();
            if (e.response.status !== 401) {
              this.toast(this.genericErrorMessage());
            }
          });
      });
    },
  },
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    draggable,
    MenuIcon,
    VueLoadImage,
  },
  created() {
    this.$emit("fields", this.field);
  },
};
</script>
<style scoped>
.modal {
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal__backdrop {
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.modal__dialog {
  background-color: #272727;
  width: 650px;
  max-height: 550px;
  min-height: 380px;
  flex-direction: column;
  border-radius: 5px;
  overflow: visible;
  position: fixed;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
}
@media screen and (max-width: 992px) {
  .modal__dialog {
    width: 90%;
    position: fixed;
    left: 50%;
    top: 55%;
    transform: translate(-50%, -50%);
  }
}
.modal__close {
  width: 30px;
  height: 30px;
}
.modal__header {
  overflow: visible;
  padding: 20px 11px 10px;
  background-color: #2c2c2e;
  position: relative;
}
.modal__body {
  padding: 8px 1px;
  width: 650px;
  max-height: 480px;
  min-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  margin-bottom: 20px;
}
</style>